import React, {Component} from "react";

class SelectList extends Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return (
            this.props.defaultLabel !== nextProps.defaultLabel
            || this.props.list !== nextProps.list
            || this.props.value !== nextProps.value
            || this.props.disabled !== nextProps.disabled
        )
    }

    handleChange(event) {
        const { id, onChange } = this.props;
        const value = event.target.value;
        onChange(id, value);
    }

    render() {
        const { className, disableDefault, defaultLabel, list, value, disabled } = this.props;
        const { handleChange } = this;

        return (
            <select
                className={className}
                value={value}
                onChange={handleChange}
                // displayEmpty
                // size="small"
                // fullWidth
                disabled={disabled}
            >
                {
                    ! disableDefault &&
                    <option value="">{defaultLabel}</option>
                }
                {
                    list.map((item, index) => (
                        <option key={index} value={item.value}>{item.label}</option>
                    ))
                }
            </select>
        )
    }
}

SelectList.defaultProps = {
    className: 'form-select',
    id: '',
    disableDefault: false,
    defaultLabel: '',
    list: [ { label: '', value: '' } ],
    value: '',
    disabled: false,
    onChange: function() {},
}

export default SelectList;
